<template>
  <transition name="navbar-slide">
    <div id='nav-margin' class="branding-active center-align" v-show='sidezoneOpen' :class="sidezoneOpen" >
      <div id="bulb-actions">
        <div class="logo">
          <img v-if="branding.logo" :src="branding.logo" style='max-width:100%' alt='company logo'></img>
          <img v-else src="https://res.cloudinary.com/playposit/image/upload/w_100/dog_white_1_jxtmbz.png" style="max-width:100%" alt='playposit logo'>
        </div>
        <div id="toggle-sidepanel" class="toggle-side-panel" :style="activeHighlight">
          <v-btn flat icon class="ma-0" @click="toggleSidePanel" :aria-label="sidePanelAriaLabel">
            <v-icon color="white" >{{iconMap[sidebarTab]}}</v-icon>
          </v-btn>
        </div>
      </div>
      <div id='question-timeline' role="region" aria-label="timeline chapter markers">
        <div id='timeline-wrapper'>
          <div v-if="hasRubric" v-show="sidebarTab !== 'rubric-tab'" class="toggle-side-panel">
            <v-btn flat icon @click="openRubric" @keyup.enter="openRubric" aria-label="Open Rubric" >
              <v-icon color="white">dns</v-icon>
            </v-btn>
        </div>
          <timeline-marker
            v-for="i in sortedInteractions"
            :interaction-id="i.id"
            :scrollbar="scrollbar"
            :key='i.id'>
          </timeline-marker>
        </div>
      </div>
      <TimeDisplay />
    </div>
  </transition>
</template>

<script>
/* eslint-disable */

// Components:
import TimelineMarker from '@/components/TimelineMarker';
import TimeDisplay from '@/components/TimeDisplay';

// Libraries
import Color from 'color'
import IScroll from 'iscroll';
import _ from 'lodash';

import {
  mapGetters,
  mapMutations,
  mapState
} from 'vuex';

export default {
  name: 'nav-margin',
  components: {
    TimeDisplay,
    TimelineMarker,
  },
  props: [
    'chat_alert', // inactive for right now
    'sidebarStyle',
  ],
  data() {
    return {
      scrollbar: null,
      iconMap: {
        'bulb-info-tab': 'assignment_turned_in',
        'notes-tab': 'note_add',
        'rubric-tab': 'dns',
        'transcript-tab':'speaker_notes',
        'broadcast-info-tab':'cast',
      },
    };
  },
  computed: {
    ...mapState('player', [
      'setFirstFocus',
    ]),
    ...mapGetters('player', [
      'bulbInitialized',
      'branding',
      'hasRubric',
      'showInteractionsTab',
      'sidebarOpen',
      'sidebarTab',
      'sidezoneOpen',
      'user',
			'isBroadcast',
			'broadcastTeacher',
    ]),
    ...mapGetters('interactions', [
      'activeInteraction',
      'activeInteractionGroup',
      'interactions',
    ]),
    activeHighlight() {
      if ((this.sidebarOpen || this.sidebarStyle === 'portrait')  && !this.showInteractionsTab) {
        if (this.branding.activeColor === '#2196F3') return {backgroundColor: '#0D47A1'};
        const hex = this.branding.baseColor || Color(this.branding.activeColor).darken(.4).hex()
        return {backgroundColor: hex}
      }
      return ''
    },
    sidePanelAriaLabel() {
      if (
        !this.showInteractionsTab
        && this.sidebarOpen
      ) return 'Close sidebar panel';
      else if (!this.sidebarOpen) return 'Open sidebar panel';
      return 'Open sidebar info panel to access review, note, and transcript tabs.';
    },
    sortedInteractions() {
      return _.sortBy(this.interactions, ['displayInTime']);
    },
    screen_height() {
      return this.$store.state.dimensions.height;
    },
  },
  methods: {
    ...mapMutations('player', [
      'setShowInteractionsTab',
      'setSidebarOpen',
      'setSidebarTab',
    ]),
    toggleSidePanel() {
      if (this.sidebarStyle !== "portrait") {
         if (this.showInteractionsTab) {
           // switch from interactions tab to review tab
          this.setSidebarOpen(true);
          this.setShowInteractionsTab(false);
          this.setFirstFocus(document.getElementById('sidebar-panel'));
        } else {
          this.setSidebarOpen(!this.sidebarOpen)
        }
      } else if (this.activeInteractionGroup.length > 0) {
        this.setShowInteractionsTab(!this.showInteractionsTab);
        this.setFirstFocus(document.getElementById('sidebar-panel'));
      } else {
        this.setShowInteractionsTab(false);
      }
    },
    openRubric () {
      this.setSidebarTab('rubric-tab')
      this.setSidebarOpen(true);
      this.setShowInteractionsTab(false);
      this.$nextTick(() => this.setFirstFocus(document.getElementById('rubric')));
      
    }
  }, // end of methods
  watch: {
    'bulbInitialized'(){
      // might be a better/different way to fix this.
      if (this.bulbInitialized) {
        this.$nextTick(() => {
          this.scrollbar.refresh();
        })
      }
    },
    'sidezoneOpen' () {
      if (this.sidezoneOpen) {
        this.$nextTick(() => this.scrollbar.refresh())
      }
    },
    'screenHeight'(){
      this.scrollbar.refresh();
    }
  },
  mounted() {
    this.scrollbar = new IScroll('#question-timeline', {
      scrollbars: true,
      mouseWheel: true,
      interactiveScrollbars: true,
      shrinkScrollbars: 'clip',
      fadeScrollbars: true,
      click: true,
      bounce: false,
      disablePointer: true,
      disableTouch: false,
      disableMouse: false
    });
  },
};
</script>

<style>
    #nav-margin{
      height:100%;
      position: relative;
      width: 55px;
      min-width: 55px;
      overflow-x: hidden;
      z-index:15;
      transition: .4s cubic-bezier(0.4, 0, 0.2, 1);
    }
    .sidezone-open #nav-margin {
      display: block;
    }

    .desktop #nav-margin {
      width: 0;
      min-width:0;
    }
    .desktop.sidezone-open #nav-margin{
      width:55px;
    }


    #bulb-actions .logo {
      height: 55px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 3px;
    }
    .toggle-side-panel{
      text-align: center;
      cursor: pointer;
    }
    .toggle-side-panel.active{
      background-color: var(--branding-active-hex);
    }

    #toggle-sidepanel button {
      border-radius: 0 !important;
      width: 55px;
      height: 55px;
    }
    #toggle-sidepanel .v-btn--icon:before {
      border-radius: 0 !important;
    }

    .divider{
      margin: 5px 10px;
      height: 1px !important;
    }

    .chatAlert{
      font-size: 1em;
      position: absolute;
      left:10px;
    }
    .show-controls{
      float: right;
    }

    #scrubber{
      top:500px;
      height: 30px;
      float: right;
      width:100%;
    }



#wrapper,#question-timeline {
  position: absolute;
  z-index: 1;
  top: 110px;
  bottom: 110px;
  left: 0;
  width: 100%;
  overflow: hidden;
}
#scroller,#timeline-wrapper {
	position: absolute;
	z-index: 1;
  margin-top: 3px;
	-webkit-tap-highlight-color: rgba(0,0,0,0);
	width: 100%;
	-webkit-transform: translateZ(0);
	-moz-transform: translateZ(0);
	-ms-transform: translateZ(0);
	-o-transform: translateZ(0);
	transform: translateZ(0);
	-webkit-touch-callout: none;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	-webkit-text-size-adjust: none;
	-moz-text-size-adjust: none;
	-ms-text-size-adjust: none;
	-o-text-size-adjust: none;
	text-size-adjust: none;
}

.iScrollVerticalScrollbar{
  width: 4px !important;
}
.iScrollIndicator{
  border:none !important;
}


.navbar-slide-enter, .navbar-slide-leave-to {
  transform: translateX(-55px) !important;
  width:0px;
}
.navbar-slide-leave, .navbar-slide-enter-to {
  transform: translateX(0) !important;
  width: 55px;
}


</style>
